import React, { useEffect, useState } from 'react';
import './App.css';

function App() {
  const [countdown, setCountdown] = useState(5);
  const newPortfolioUrl = 'https://johnklucinec.vercel.app/';
  const particleSystemUrl = 'https://johnklucinec.github.io/OpenCL-OpenGL-Particle-System/';

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      window.location.href = newPortfolioUrl;
    }
  }, [countdown]);

  return (
    <div className="redirect-container">
      <div className="gradient-blur"></div>
      <div className="content">
        <div className="card">
          <h1>Portfolio Relocated</h1>
          <p className="description">You'll be redirected to the new experience in</p>
          <div className="countdown">{countdown}</div>
          <button onClick={() => window.location.href = newPortfolioUrl}>
            Continue to new portfolio
            <span className="arrow">→</span>
          </button>
          <p className="projects-note">
            While you wait, check out my{' '}
            <a href={particleSystemUrl}>
              OpenCL &amp; OpenGL Particle System
            </a>{' '}
            project.
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;
